import { create } from 'zustand';

const CACHE_KEY = 'pp_cached_org_context';

export function readCachedOrgContext() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function writeCachedOrgContext(ctx) {
  try {
    if (!ctx) localStorage.removeItem(CACHE_KEY);
    else localStorage.setItem(CACHE_KEY, JSON.stringify(ctx));
  } catch {
    /* ignore */
  }
}

export const useMeetingLiveStore = create((set) => ({
  organizationId: null,
  organizationName: null,

  setOrganizationContext: (organizationId, organizationName = null) => {
    set({
      organizationId,
      organizationName: organizationName ?? null,
    });
  },

  reset: () =>
    set({
      organizationId: null,
      organizationName: null,
    }),
}));
